import { memo, useCallback, useContext, useEffect, useState } from "react";
import "./style.scss";
import { UserContext } from "store";
import Modal from "components/LoginAndRegister/Modal";
import { toast } from "react-toastify";
import PhoneInput from "react-phone-input-2";
import { goAxiosInstance } from "helpers/axiosInstance";
import { useTheme } from "components/ListingNew/ListingTheme";

const ListingPdf = memo(
	({ id, villaName }: { id: string; villaName: string }) => {
		const {
			state: { currentUser },
		} = useContext(UserContext);
		const [open, setOpen] = useState(false);
		const [loader, setLoader] = useState(false);
		const [mobileNumber, setMobileNumber] = useState("");
		const [email, setEmail] = useState("");
		const [cc, setCc] = useState("+91");
		const [phoneIsValid, setPhoneIsValid] = useState(false);

		useEffect(() => {
			setEmail(currentUser.email);
			setMobileNumber(currentUser.mobile);
			setCc(currentUser.cc);
		}, [currentUser]);

		const theme = useTheme();

		const getPDFHandler = useCallback(async () => {
			try {
				setLoader(true);
				const res = await goAxiosInstance(
					`/send-listing-pdf?listing_id=${id}&cc=${cc}&phone=${mobileNumber}&email=${email}`,
				);
				toast.success(res.data.message, {
					position: window.innerWidth < 800 ? "top-right" : "bottom-right",
					autoClose: 3000,
					hideProgressBar: false,
					icon: true,
					closeOnClick: false,
					pauseOnHover: false,
					draggable: false,
					progress: undefined,
				});
				setOpen(false);
			} catch (err: any) {
				toast.error(err?.response?.data?.message || "Try Again!", {
					position: window.innerWidth < 800 ? "top-right" : "bottom-right",
					autoClose: 3000,
					hideProgressBar: false,
					icon: true,
					closeOnClick: false,
					pauseOnHover: false,
					draggable: false,
					progress: undefined,
				});
			} finally {
				setLoader(false);
			}
		}, [email, cc, mobileNumber]);

		return (
			<>
				{open && (
					<Modal
						shouldShow={open}
						onRequestClose={() => {
							setOpen(false);
						}}
					>
						<div className="listing-pdf-popup">
							<h3>Please enter the details below</h3>
							<PhoneInput
								country={"in"}
								value={cc + mobileNumber}
								enableSearch={true}
								isValid={(value, country): any => {
									//@ts-ignore
									if (country?.countryCode !== "91") {
										setPhoneIsValid(true);
										return true;
									} //@ts-ignore
									if (country?.countryCode === "91" && value.length === 12) {
										setPhoneIsValid(true);
										return true;
									} else {
										setPhoneIsValid(false);
										return false;
									}
								}}
								onChange={(value, country, e, formattedValue): any => {
									//@ts-ignore
									setCc(country?.dialCode || "");
									setMobileNumber(
										//@ts-ignore
										value.slice(country?.dialCode?.toString()?.length || ""),
									);
								}}
							/>
							<input
								placeholder="Email"
								value={email}
								onChange={(e) => {
									setEmail(e.target.value);
								}}
							/>

							<div className="btn-wrapper">
								<button
									onClick={() => {
										setOpen(false);
									}}
								>
									Close
								</button>
								<button
									className={`blue-btn ${loader ? "button__loader" : ""}`}
									disabled={loader || !email || !phoneIsValid}
									onClick={getPDFHandler}
								>
									{loader ? "Loading..." : "Submit"}
								</button>
							</div>
						</div>
					</Modal>
				)}
				<div className="listing-pdf-wrapper" style={{ ...theme?.borderBtn }}>
					<span
						style={
							Object.keys(theme || {}).length !== 0
								? {
										color: theme?.primaryTextColor,
								  }
								: {}
						}
					>
						Want to know more about the villa?
					</span>{" "}
					<button
						onClick={() => {
							// setOpen(true);
							window.open(
								`https://api.whatsapp.com/send/?phone=918291050012&text=Send%20me%20a%20PDF%20for%20${villaName}--${id}`,
							);
						}}
						style={
							Object.keys(theme || {}).length !== 0
								? {
										background: theme?.bookingBtnBackground,
								  }
								: {}
						}
					>
						Get PDF now
					</button>
				</div>
			</>
		);
	},
);

export default ListingPdf;
